import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import {AuthComponent} from './theme/layout/auth/auth.component';

const routes: Routes = [
  
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./admin/pages/authentication/authentication.module').then(module => module.AuthenticationModule)
      }
    ]
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./admin/dashboard/dashboard.module').then(module => module.DashboardModule)
      },
     
      {
        path: 'basic',
        loadChildren: () => import('./admin/ui-elements/ui-basic/ui-basic.module').then(module => module.UiBasicModule)
      },
     
      {
        path: 'feedback-page',
        loadChildren: () => import('./admin/pages/feedback-page/feedback-page.module').then(module => module.FeedbackPageModule)
      },
      {
        path: 'home',
        loadChildren: () => import('./admin/pages/home-page/home-page.module').then(module => module.HomePageModule)
      },
      {
        path: 'analytics',
        loadChildren: () => import('./admin/pages/analytics-page/analytics-page.module').then(module => module.AnalyticsPageModule)
      },
     

    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
